// ==============================================
// ================Import Actions================
// ==============================================

import {
  SAVE_NETWORK_FULL_DATA,
  SET_NETWORK_GRID,
  SET_NETWORK_MARKER,
  SET_NETWORK_NAME,
  SET_SAVE_MARKER_SELECTED,
  SET_SAVE_NETWORK_ARRAY,
  SET_SAVE_NETWORK_MARKER_COMPONENT,
} from '../actions/network';

// ==============================================
// ================InitialState==================
// ==============================================
const initialState = {
  networkArray: [],
  networkComponent: [],
  networkMarker: false,
  networkGrid: [],
  networkFullData: [],
  networkName: '',
  rowMarkerSelected: [],
};

// ==============================================
// ===================Reducer====================
// ==============================================

function networkReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SAVE_NETWORK_ARRAY:
      return {
        ...state,
        networkArray: action.value,
      };
    case SET_SAVE_NETWORK_MARKER_COMPONENT:
      return {
        ...state,
        networkComponent: action.value,
      };
    case SET_NETWORK_MARKER:
      return {
        ...state,
        networkMarker: action.value,
      };
    case SET_NETWORK_GRID:
      return {
        ...state,
        networkGrid: action.value,
      };
    case SAVE_NETWORK_FULL_DATA:
      return {
        ...state,
        networkFullData: action.value,
      };
    case SET_NETWORK_NAME:
      return {
        ...state,
        networkName: action.value,
      };
    case SET_SAVE_MARKER_SELECTED:
      return {
        ...state,
        rowMarkerSelected: action.value,
      };
    default:
      return state;
  }
}

export default networkReducer;
